import { render, staticRenderFns } from "./AppLoading.vue?vue&type=template&id=5624eddd&scoped=true&"
import script from "./AppLoading.vue?vue&type=script&lang=js&"
export * from "./AppLoading.vue?vue&type=script&lang=js&"
import style0 from "./AppLoading.vue?vue&type=style&index=0&id=5624eddd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5624eddd",
  null
  
)

export default component.exports